<template lang="html">
<div class="main-body">
    <div class="main-body-search">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input
              v-model="filters.userAccount"
              placeholder="用户名称"
              @keyup.enter.native="getList">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filters.personName"
              placeholder="人员名称"
              @keyup.enter.native="getList">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="getList" >查询</el-button>
          </el-form-item>
        </el-form>
    </div>
    <div class="main-body-table">
      <!--列表-->
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column type="index" width="60">
        </el-table-column>
        <el-table-column
          prop="personName"
          label="姓名"
          width="150">
        </el-table-column>
        <el-table-column
          prop="userAccount"
          label="用户账号"
          width="200">
        </el-table-column>
        <el-table-column
          prop="userType"
          label="用户类型"
          width="100">
           <template slot-scope="scope">
              <span>{{$t(scope.row.userType)}}</span>
            </template>
        </el-table-column>
        <el-table-column
          prop="userCategory"
          label="用户分类"
          width="100">
             <template slot-scope="scope">
  <span>{{$t(scope.row.userCategory)}}</span>
</template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          width="90">
          <template slot-scope="scope">
  <el-tag v-if="scope.row.action === 1" :type="scope.row.action === 2 ? 'danger' : 'success'" close-transition>
    增加
  </el-tag>
  <el-tag v-if="scope.row.action === 2" :type="scope.row.action === 2 ? 'danger' : 'success'" close-transition>
    删除
  </el-tag>
  <el-tag v-if="scope.row.action === 3" close-transition>
    更新
  </el-tag>
</template>
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="所属机构">
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
  <el-button type="info" size="small" @click="showDetail(scope.$index, scope.row)">详情</el-button>
  <el-button type="success" size="small" @click="handlePass(scope.$index, scope.row)">通过</el-button>
  <el-button type="danger" size="small" @click="showForm(1, scope.$index, scope.row)">拒绝</el-button>
</template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-pagination class="main-body-table-page" layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :current-page="page.current" :page-size="page.size" :total="page.total">
      </el-pagination>
  </div>
  <!--新增界面-->
  <el-dialog v-dialogDrag  ref="approvadialog" title="拒绝说明" :visible.sync="userApprovalFormVisible" :close-on-click-modal="false">
    <el-form :model="userApprovalForm" label-width="80px" :rules="userApprovalFormRules" ref="userApprovalForm">
      <el-form-item label="拒绝原因" prop="appName">
        <el-input
          type="textarea"
          v-model="userApprovalForm.appName"
          :row="4"
          placeholder="请输入内容">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="userApprovalFormVisible = false">取消</el-button>
      <el-button type="danger"  @click="handleNotPass" :loading="formLoading">审核不通过</el-button>
    </div>
  </el-dialog>
   <!--详情界面-->
    <el-dialog title="用户详情" :visible.sync="detailFormVisible" :close-on-click-modal="false">
        <el-form :model="detailForm" label-width="80px"  ref="detailForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名称" prop="userAccount">
                <el-input v-model="detailForm.userAccount"></el-input>
              </el-form-item>
            </el-col>
           <el-col :span="12">
               <el-form-item label="用户类型" prop="userType">
                    <el-input v-model="detailForm.userType"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户分类" prop="userCategory">
                  <el-input v-model="detailForm.userCategory"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态" prop="status">
                <el-input v-model="detailForm.status"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
               <el-form-item label="所属人员" prop="personName">
                    <el-input v-model="detailForm.personName"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
               <el-form-item label="组织机构" prop="orgName">
                 <el-input v-model="detailForm.orgName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-tag>角色列表</el-tag>
           <el-row type="flex" class="row-bg" justify="center">
                <el-table ref="RoleTableRef" :data="appRoleTableData" tooltip-effect="dark"  height="320">
                    <el-table-column type="selection" width="55" :selectable="selectRoleTableFunc"></el-table-column>
                    <el-table-column prop="appName" label="所属应用" width="200"></el-table-column>
                    <el-table-column prop="roleName" label="角色" width="200"></el-table-column>
                    <el-table-column prop="detail" label="描述" width="280"></el-table-column>
                 </el-table>
            </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="detailFormVisible = false">关闭</el-button>
        </div>
      </el-dialog>
</div>
</template>

<script>
import {
  savePass,
  saveNotPass,
  getApprovalUsers
} from '../../api/sum/UserApproval'
export default {
  data() {
    return {
      filters: {
        userAccount: '',
        personName: ''
      },
      page: {
        current: 1, // 当前页
        size: 5, // 每页个数
        total: 0 // 默认数据总数
      },
      userApprovalForm: {},
      userApprovalFormRules: {
        appName: [
          { required: true, message: '请输入拒绝原因', trigger: 'blur' }
        ]
      },
      detailForm: {},
      detailFormVisible: false,
      appRoleTableData: [],
      formLoading: false,
      userApprovalFormVisible: false,
      tableData: []
    }
  },
  mounted() {
    // 默认查询
    this.getList()
  },
  methods: {
    handleCurrentChange(val) {
      this.page.current = val
      this.getList()
    },
    // 查询
    getList() {
      this.filters.current = this.page.current
      this.filters.size = this.page.size
      getApprovalUsers(this.filters)
        .then(response => {
          this.tableData = response.data.records
          this.page.total = response.data.total
        })
        .catch(err => {
          // {data, status}
          console.log(err)
        })
    },
    // 审核不通过
    handleNotPass() {
      this.$refs.userApprovalForm.validate(valid => {
        if (valid) {
          this.formLoading = true
          this.userApprovalForm.status = 1
          saveNotPass(this.userApprovalForm)
            .then(response => {
              //
              this.formLoading = false
              this.userApprovalFormVisible = false
              if (response.code === 20000) {
                this.$message({
                  message: '审核不通过成功',
                  type: 'success'
                })
                this.getList()
              } else {
                this.$message({
                  message: response.msg,
                  type: 'error'
                })
              }
            })
            .catch(err => {
              //
              this.formLoading = false
              console.log(err)
              this.$message({
                message: '审核不通过失败',
                type: 'error'
              })
            })
        }
      })
    },
    // 审核通过
    handlePass(index, row) {
      this.$confirm('确认审核通过该记录吗?', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.formLoading = true
          row.status = 1
          savePass(Object.assign({}, row))
            .then(response => {
              this.formLoading = false
              if (response.code === 20000) {
                setTimeout(() => {
                  this.$message({
                    message: '审核通过成功',
                    type: 'success'
                  })
                }, 200)
                this.getList()
              } else {
                setTimeout(() => {
                  this.$message({
                    message: response.msg,
                    type: 'error'
                  })
                }, 200)
              }
            })
            .catch(err => {
              //
              this.formLoading = false
              console.log(err)
              this.$message({
                message: '审核通过失败',
                type: 'error'
              })
            })
        })
        .catch(() => {})
    },
    selectRoleTableFunc(row, index) {
      return false
    },
    // 显示用户详情
    showDetail(index, row) {
      this.detailFormVisible = true
      this.detailForm = Object.assign({}, row)
      this.initAppRoleList()
      if (this.detailForm.userType === 0) {
        this.detailForm.userType = '管理用户'
      } else {
        this.detailForm.userType = '岗位用户'
      }
      if (this.detailForm.userCategory === 0) {
        this.detailForm.userCategory = '证书用户'
      } else {
        this.detailForm.userCategory = '普通用户'
      }
      if (this.detailForm.status === 1) {
        this.detailForm.status = 'normal'
      } else if (this.detailForm.status === 2) {
        this.detailForm.status = 'locked'
      } else if (this.detailForm.status === 3) {
        this.detailForm.status = 'forzen'
      } else {
        this.detailForm.status = 'cancelled'
      }
    },
    // 初始化应用角色列表
    initAppRoleList() {
      let param = { orgId: this.detailForm.orgId }
      this.$http
        .post('/sum/sumRole/selectAppRoleByOrgId', param)
        .then(res => {
          if (res.code === 20000) {
            this.appRoleTableData = res.data
            // 编辑状态
            this.appRoleTableData.forEach(row => {
              let roleIdArray = this.detailForm.roleIds.split(',')
              if (roleIdArray.indexOf(row.id) !== -1) {
                this.$nextTick(() => {
                  this.$refs.RoleTableRef.toggleRowSelection(row)
                })
              }
            })
          }
        })
        .catch(rej => {
          console.log(rej)
        })
    },
    // 显示表单
    showForm(type, index, row) {
      this.userApprovalFormVisible = true
      this.$nextTick(() => {
        this.$refs.userApprovalForm.clearValidate()
      })
      this.formType = type
      this.userApprovalForm = Object.assign({}, row)
    }
  }
}
</script>

<style lang="css">
</style>
